import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [{
        path: "/",
        name: "Home",
        component: Home
    },
    //驾校
    {
        path: "/School/Schoolmanage",
        name: "Schoolmanage",
        component: () =>
            import ("../views/School/Schoolmanage.vue")
    },
    {
        path: "/School/Index",
        name: "Sindex",
        component: () =>
            import ("../views/School/Index.vue")
    },
    {
        path: "/School/Smallapp",
        name: "SSmallapp",
        component: () =>
            import ("../views/School/Smallapp.vue")
    },
    {
        path: "/School/Wemedia",
        name: "SWemedia",
        component: () =>
            import ("../views/School/Wemedia.vue")
    },
    {
        path: "/School/Cmedia",
        name: "SCmedia",
        component: () =>
            import ("../views/School/Cmedia.vue")
    },



    //合作伙伴
    {
        path: "/Partner/index",
        name: "Pindex",
        component: () =>
            import ("../views/Partner/index.vue")
    },

    //关于
    {
        path: "/About/Index",
        name: "Aindex",
        component: () =>
            import ("../views/About/Index.vue")
    },
];

const router = new VueRouter({
    routes
});

export default router;